// src/main.jsx
// IMPORTANT: Import logger first to override console methods before any other code runs
import './utils/logger';

import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import './enhanced.css'
import App from './App.jsx'
import './i18n'
import { initAutoClickTracking, initSessionLeaveTracking } from './utils/analytics'
import { registerServiceWorker } from './utils/serviceWorkerRegistration'

initAutoClickTracking();
initSessionLeaveTracking();
registerServiceWorker();

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// react-snap pre-renders pages as static HTML; use hydrateRoot to attach React
// to the existing markup instead of re-rendering from scratch.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}